<template>
  <layout class="error">
    <div class="wrapper" @touchmove.prevent>
      <div class="container">
        <template v-if="error.statusCode === 404">
          <h1 slot="title" class="sf-sb sf-c-primary">{{ $t('layout.404-title') }}</h1>
          <p>{{ $t('layout.404-text') }}</p>
          <i18n path="layout.400-text2" tag="p">
            <app-email-link :email="$t('contacts-page.email-cc')"/>
          </i18n>
        </template>

        <template v-else>
          <h1 slot="title" class="sf-sb sf-c-primary">{{ $t('layout.500-title') }}</h1>
        </template>

        <debug/>
      </div>
    </div>
  </layout>
</template>

<script>
import ErrorPage from '~core/pages/error';
import Layout from '~lib/src/layouts/blank';
import AppEmailLink from '~/components/links/email-link.vue';

export default {
  components: { Layout, AppEmailLink },
  extends: ErrorPage,
};
</script>

<style lang="scss" scoped>
.error {
  background: #fff;

  /deep/ .blank__inner {
    padding-top: 0;
  }
}
.wrapper {
  @extend %overlay;
  @extend %centered;
  position: fixed;
  flex-direction: column;
  z-index: 100;
  background: rgba(255, 255, 255, 1);
}

.container {
  text-align: center;
  max-width: 1200px;
  width: 100%;
}
</style>
